import script from "./BlockLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockLogo.vue?vue&type=script&setup=true&lang=js"

import "./BlockLogo.vue?vue&type=style&index=0&id=168bdf0e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-168bdf0e"]])

export default __exports__